export default {
  homePage: "Startpagina",
  close: "Sluiten",
  bestSelling: "Best verkocht",
  seeAllProduct: "Bekijk alle producten",
  quickView: "Snelle weergave",
  addToWishlist: "Toevoegen aan verlanglijst",
  addToCompare: "Toevoegen aan vergelijking",
  compare: "Vergelijken",
  addToCart: "Toevoegen aan winkelwagen",
  searchTitle: "Zoeken",
  searchButton: "Zoeken",
  searchPlaceholder: "Zoek hier..",
  checkout: "Afrekenen",
  viewCart: "Bekijk winkelwagen",
  subtotal: "Subtotaal",
  cartQuantity: "Winkelwagen ({count})",
  filter: "Filter",
  sortby: "Sorteren op",
  showFilters: "Toon filters",
  collection: "Collectie",
  category: "Categorie",
  materials: "Materialen",
  stones: "Stenen",
  viewResult: "Bekijk resultaat",
  relatedProducts: "Gerelateerde producten",
  nextBtn: "Volgende",
  prevBtn: "Vorige",
  byAuthor: "Door {author}",
  articles: "Artikelen",
  allArticles: "Alle artikelen",
  recentlyViewed: "Recent bekeken",
  backTohomepage: "Terug naar startpagina",
  text404: "Deze pagina is waarschijnlijk verplaatst.",
  latestArticles: "Laatste artikelen",
  all: "alle",
  searchInBlog: "Zoeken in blog",
  shopCategories: "Winkelcategorieën",
  shopNow: "Nu winkelen",
  status: "Status",
  buyNow: "Koop nu",
  back: "Terug",
  forgotPassword: "Wachtwoord vergeten?",
  emailAddressPlaceholder: "E-mailadres",
  passwordPlaceholder: "Wachtwoord",
  firstNamePlaceholder: "Voornaam",
  lastNamePlaceholder: "Achternaam",
  submit: "Verzenden",
  signIn: "Inloggen",
  signOut: "Uitloggen",
  createAccount: "Account aanmaken",
  forgotTitle: "Reset je wachtwoord",
  forgotDesc:
    "Voer het e-mailadres in dat aan je account is gekoppeld. Klik op verzenden om je wachtwoord per e-mail te ontvangen.",
  loginTitle: "Bestaande klanten",
  loginDesc: "Log hieronder in op je account:",
  registerTitle: "Nieuwe klanten",
  registerDesc: "Maak hieronder een account aan:",
  profile: "Profiel",
  myOrders: "Mijn bestellingen",
  wishlist: "Verlanglijst",
  addedToWishlist: "Toegevoegd aan verlanglijst",
  compared: "Vergeleken",
  product: "Product",
  price: "Prijs",
  qty: "Aantal",
  edit: "Bewerken",
  cartEmpty: "Winkelwagen is leeg",
  discountCode: "Kortingscode",
  discountCodePlaceholder: "Voer promotiecode in",
  applyCoupon: "Toepassen",
  orderSummary: "Besteloverzicht",
  total: "Totaal",
  proceedToCheckout: "Doorgaan naar afrekenen",
  acceptPaymentMethods: "Geaccepteerde betaalmethoden",
  continueShopping: "Verder winkelen",
  shoppingCart: "Winkelwagen",
  companyPlaceholder: "Bedrijfsnaam",
  streetAddressPlaceholder: "Straatadres",
  cityPlaceholder: "Stad",
  zipCodePlaceholder: "Postcode",
  phoneNumberPlaceholder: "Telefoonnummer",
  shipToDifferentAddress: "Verzenden naar een ander adres?",
  orderNotePlaceholder: "Opmerking bij bestelling (optioneel)",
  privacyText:
    "Je persoonlijke gegevens worden gebruikt om je bestelling te verwerken, je ervaring op deze website te ondersteunen en voor andere doeleinden zoals beschreven in ons",
  privacyPolicy: "Privacybeleid",
  returnPolicy: "Retourbeleid",
  placeOrder: "Bestelling plaatsen",
  yourOrder: "Je bestelling",
  billingDetail: "Facturatiegegevens",
  apply: "Toepassen",
  logInYourAccount: "Log in op je account",
  shopByTheLook: "Shop op look",
  instagramBlockSubtitle: "Volg ons op Instagram of tag ons met",
  thanksOrder: "Bedankt voor je bestelling!",
  orderCompleteDesc:
    "We maken je bestelling klaar voor verzending. We laten het weten zodra het is verzonden",
  orderNumber: "Bestelnummer",
  customerInformation: "Klantgegevens",
  shippingAddress: "Verzendadres",
  billingAddress: "Factuuradres",
  customerDetails: "Klantgegevens",
  deliveryDetail: "Leveringsgegevens",
  needHelp: "Hulp nodig? Neem contact met ons op",
  policyBanner:
    "Deze website gebruikt cookies om ervoor te zorgen dat je de beste ervaring op onze website hebt.",
  gotIt: "Begrepen",
  acceptFor: "Accepteren voor",
  subscribe: "Abonneren",
  bySubscribingYouAcceptThe: "Door je te abonneren accepteer je het",
  beTheFirstToGetTheLatestNewsAboutTrendsPromotionsAndMuchMore:
    "Wees als eerste op de hoogte van het laatste nieuws over trends, promoties en meer!",
  newsletter: "Nieuwsbrief",
  omara: "OMARA",
  home: "Home",
  youHaveSuccessfullySubscribed: "Je bent succesvol geabonneerd",
  noData: "Geen gegevens",
  noImages: "Geen afbeeldingen",
  success: "Succes",
  error: "Fout",
  serverError: "Serverfout",
  confirmMessage:
    "Registratie was succesvol, volg de instructies in de e-mail die naar je is verzonden",
  recoverPasswordMessage:
    "Formulier succesvol verzonden, volg de instructies in de e-mail die naar je is verzonden",
  emailVerifySuccess: "Je e-mailadres is succesvol geverifieerd",
  passwordRecoverySuccess: "Je wachtwoord is succesvol hersteld",
  passwordUpdateSuccess: "Je wachtwoord is succesvol bijgewerkt",
  loading: "Laden",
  blogPageTitle: "Ons Journal",
  blogPageDescription:
    "Er zijn veel variaties van passages van Lorem Ipsum beschikbaar, maar de meeste zijn gewijzigd op een of andere manier, door toegevoegde humor",
  passwordRecovery: "wachtwoordherstel",
  pleaseFillTheForm: "Vul het formulier in",
  newPassword: "Nieuw wachtwoord",
  confirmNewPassword: "Bevestig nieuw wachtwoord",
  recover: "Herstellen",
  catalog: "Catalogus",
  showMore: "Toon meer",
  showLess: "Toon minder",
  shipping: "Verzending",
  shippingDetail: "Verzenddetails",
  free: "Gratis",
  directBankTransfers: "Overschrijvingen via bank",
  giftCard: "Cadeaubon",
  giftCardAmount: "Waarde cadeaubon",
  discount: "Korting",
  view: "Bekijken",
  expressCheckout: "Snelle afrekening",
  or: "of",
  allTransactionsAreSecureAndEncrypted:
    "Alle transacties zijn veilig en versleuteld.",
  yourOrderIsFree: "Je bestelling is gratis, betaling is niet vereist.",
  payment: "Betaling",
  change: "Wijzigen",
  shipTo: "verzenden naar",
  contact: "contact",
  completeOrder: "Bestelling afronden",
  estimateDeliveryDate: "Verwachte leverdatum",
  yourMessageIsSent: "Je bericht is verzonden",
  weWillGetBackToYouWithAnAnswerAsSoonAsPossible:
    "We nemen zo snel mogelijk contact met je op met een antwoord.",
  email: "E-mail",
  birthday: "Verjaardag",
  save: "Opslaan",
  changeUserInfoText: "Gebruikersinformatie bijgewerkt",
  updatePassword: "Wachtwoord bijwerken",
  currentPassword: "Huidig wachtwoord",
  changeUserPasswordText: "Gebruikerswachtwoord bijgewerkt",
  yourEmailPreferences: "Je e-mailvoorkeuren",
  selectWhichEmailsYouWouldLikeToReceive:
    "Selecteer welke e-mails je wilt ontvangen:",
  changePassword: "Wachtwoord wijzigen",
  updateEmailPreferences: "E-mailvoorkeuren bijwerken",
  dateOrdered: "besteldatum",
  orderNo: "bestelnummer",
  returns: "Retouren",
  orderTotal: "totaal bestelling",
  orderDetails: "bestelgegevens",
  paymentSummary: "Betalingsoverzicht",
  discountCard: "Kortingskaart",
  tax: "Belasting",
  productDiscount: "Productkorting",
  paymentMethod: "betaalmethode",
  deliveryAddress: "bezorgadres",
  shippingAddresses: "Verzendadressen",
  addNewAddress: "nieuw adres toevoegen",
  create: "Aanmaken",
  editAddress: "Adres bewerken",
  addressDeleted: "Adres verwijderd",
  deleteAddress: "Adres verwijderen",
  addressAdded: "Adres toegevoegd",
  addressEdited: "Adres bewerkt",
  orderTracking: "Bestelling volgen",
  estimatedDelivery: "Geschatte levering",
  completed: "Voltooid",
  inProgress: "In behandeling",
  next: "Volgende",
  textMeStatusUpdates: "SMS STATUS UPDATES",
  collections: "Collecties",
  fromPrice: "Vanaf {price}",
  stoneSizeInMm: "Steenmaat (mm)",
  caratWeight: "Karaatgewicht (kt)",
  selectSize: "Selecteer maat",
  millimetersMmToCaratWeight: "millimeters naar karaatgewicht",
  hideMmToCaratWeightChart: "Verberg mm-naar-karaat tabel",
  showMmToCaratWeightChart: "Toon mm-naar-karaat tabel",
  mMSize: "Maat in mm",
  roundCut: "Ronde Slijpvorm",
  round: "Rond",
  princessSquareCut: "Princess Slijpvorm",
  princess: "Princess",
  asscherCut: "Asscher Slijpvorm",
  asscher: "Asscher",
  cushionCut: "Kussen Slijpvorm",
  cushion: "Kussen",
  ovalCut: "Ovale Slijpvorm",
  oval: "Ovaal",
  radiantCut: "Radiant Slijpvorm",
  radiant: "Radiant",
  pearCut: "Peer Slijpvorm",
  pear: "Peer",
  heartCut: "Hartvormige Slijpvorm",
  heart: "Hart",
  marquiseCut: "Marquise Slijpvorm",
  marquise: "Marquise",
  triangleCut: "Driehoekige Slijpvorm",
  triangle: "Driehoek",
  trillionCut: "Trillion Slijpvorm",
  trillion: "Trillion",
  baguetteStraightCut: "Rechte Baguette Slijpvorm",
  baguette: "Baguette",
  baguetteTaperedCut: "Tapered Baguette Slijpvorm",
  taperedBaguette: "Tapered Baguette",
  emeraldCut: "Smaragd Slijpvorm",
  emerald: "Smaragd",
  enterPromoCode: "Voer promotiecode in",
  resetAll: "Alles resetten",
  troubleCreateOrder: "Er is momenteel een probleem met het aanmaken van een bestelling.",
  estimatedDeliveryDate: "Geschatte leverdatum",
  orderNotes: "Bestelnotities",
  deliveryMethod: "Verzendmethode",
  selectShippingMethod: "Kies verzendmethode",
  estimated: "Geschat",
  days: "dagen",
  brand: "Merk",
  productDetails: "Productdetails",
  acceptAll: "Alles accepteren",
  selectACountry: "Selecteer een land",
  continue: "Doorgaan",
  shippingMethod: "Verzendmethode",
  finalizeAndPay: "Voltooien en betalen",
  createOrderErrorText: "Fout bij het aanmaken van bestelling. Neem contact op met support.",
  createSessionErrorText: "Er is iets misgegaan. Probeer opnieuw.",
  // Mollie payment error messages
  molliePaymentError: "Fout bij verwerken betaling. Probeer opnieuw.",
  mollieInitError: "Initialisatie betalingssysteem mislukt. Ververs de pagina.",
  mollieScriptLoadError: "Betalingssysteem kon niet worden geladen. Controleer je internetverbinding.",
  mollieCardTokenError: "Kaartvalidatie mislukt. Controleer je kaartgegevens.",
  mollieProfileIdError: "Fout in betalingsconfiguratie. Neem contact op met support.",
  mollieInvalidFieldsError: "Een of meer velden zijn ongeldig",
  mollieComponentsNotMountedError: "Niet alle vereiste componenten zijn geladen, zie https://docs.mollie.com/guides/mollie-components/reference voor meer informatie.",
  paymentFailed: "Betaling mislukt. Probeer opnieuw of gebruik een andere betaalmethode.",
  paymentPending: "Betaling wordt verwerkt. Wacht even terwijl we je betaling verwerken.",
  paymentExpired: "Betalingssessie verlopen. Probeer opnieuw.",
  cart: "Winkelwagen",
  review: "Beoordeling",
  filterTitles: {
    collections: "Collecties",
    categories: "Categorieën",
    materials: "Materialen",
    stones: "Edelstenen",
    headstyles: "Kopstijlen",
    stoneshapes: "Vorm edelsteen",
  },
  configurator: {
    item: "Item",
    startingAt: "Vanaf",
    total: "Totaal",
    addToBag: "In winkelwagen",
    remove: "Verwijderen",
    addItem: "Item toevoegen",
    characters: "Karakters",
    yourDesign: "Jouw ontwerp",
    openMap: "Open kaart",
    latitude: "Breedtegraad",
    longitude: "Lengtegraad",
    clear: "Wissen",
    clearAll: "Alles wissen",
    addedToWishlist: "Toegevoegd aan verlanglijst",
    addToWishlist: "Voeg toe aan verlanglijst",
    compare: "Vergelijken",
    addedToCompareList: "Toegevoegd aan vergelijkingslijst",
    size_guide: "Maattabel",
    outOfStock: "Niet op voorraad",
    productDetails: "Productdetails",
  },
  paymentStatus: "Betaalstatus",
  unpaid: "Niet betaald",
  paid: "Betaald",
  refundStarted: "Terugbetaling gestart",
  refunded: "Terugbetaald",
  partiallyRefunded: "Gedeeltelijk terugbetaald",
  voided: "Geannuleerd",
  fillTheFormBelow: "Vul onderstaand formulier in",
  newClients: "Nieuwe klanten",
  createMyAccount: "Maak mijn account aan",
  createAnAccountByClickingBelow: "Maak een account aan via onderstaande knop en ontvang",
  percentOff: "{percent}% korting",
  yourFirstOrder: "op je eerste bestelling",
  yourCartIsEmpty: "Je winkelwagen is leeg",
  login: "Inloggen",
  sorting: "Sortering",
  priceFromLowestToHighest: "Prijs: laag naar hoog",
  priceFromHighestToLowest: "Prijs: hoog naar laag",
  defaultV: "standaard",
  use: "Gebruiken",
  notificationLanguage: "Taal meldingen",
  onlinePayment: "Online betaling",
  card: "Kaart",
  bankTransfer: "Overschrijving",
  paymentMethodC: "Betaalmethode",
  bankTransferDisclaimer: "Je ontvangt een e-mail met alle betalingsgegevens",
  stripeDisclaimer:
    "Je betalingsgegevens worden veilig verwerkt door <a href='https://stripe.com/nl/resources/more/secure-payment-systems-explained' target='_blank'>Stripe</a>. Wij slaan je kaartgegevens niet op.",
  mollieDisclaimer:
    "Je betalingsgegevens worden veilig verwerkt door <a href='https://www.mollie.com/en/security' target='_blank'>Mollie</a>. Wij slaan je kaartgegevens niet op.",
  selectJewelry: "Selecteer sieraden",
  nextStep: "Volgende stap",
  gold: "Goud",
  platinum: "950 Platina",
  silver: "925 Zilver",
  goldOverSilver: "Verguld zilver",
  recommended: "Aanbevolen",
  thePerfectComplement: "De perfecte aanvulling",
  description: "Beschrijving",
  shipReturn: "Verzending & retour",
  askAQuestion: "Veelgestelde vragen",
  closePopup: "Sluit popup",
  closeFilter: "Sluit filter",
  toggleMenu: "Toon/verberg menu",
  removeFromComparison: "Verwijderen uit vergelijking",
  removeFromWishlist: "Verwijderen uit verlanglijst",
  closeCartDrawer: "Sluit winkelwagen",
  closeSizeGuideDrawer: "Sluit maattabel",
  ringSizeGuide: "Ringmaattabel",
  unableToLoadSizeGuide: "Kon maattabel niet laden",
  removeDiscount: "Verwijder korting",
  openFilePreview: "Bekijk bestand",
  closeSearchPopup: "Sluit zoekpopup",
  closeModal: "Sluit venster",
  removeCartItem: "Verwijder uit winkelwagen",
  ariaGoToSlide: "Ga naar slide {index}",
  ariaPrevSlide: "Vorige slide",
  ariaNextSlide: "Volgende slide",
  viewThePhotoOnInstagram: "Bekijk de foto op Instagram",
  ariaViewProduct: "Bekijk product {title}",
  ariaBackTo: "Terug naar {title}",
  thankYouForSubscription: "Bedankt voor je aanmelding",
  thankYouForSubscribingExploreOurExclusiveJewelryCollectionsAndStayTunedForUpdates: "Bedankt voor je inschrijving! Ontdek onze exclusieve collecties en blijf op de hoogte!",
  startShoppingNow: "Begin nu met winkelen",
  didntReceiveYourEmail: "Geen e-mail ontvangen?",
  checkYourSpamFolderOrContactOurSupport: "Controleer je spamfolder of <a href='mailto:info@omara.sk'>neem contact op</a>.",
  dontHaveAnAccountSignUp: "Nog geen account? Meld je aan",
  alreadyHaveAnAccountLogIn: "Heb je al een account? Log in",
  bannerImage: "Banner afbeelding",
  outOfStock: "Niet op voorraad",
  requestPrice: "Vraag prijs aan",
  continueWith: "Doorgaan met {title}",
  orSignIn: "Of log in",
  orSignUp: "Of meld je aan",
  remove: "Verwijderen",
  discountCodeAndGiftCardsNotice: "<span class='tw-font-semibold'>Kortingscodes:</span> Slechts één kortingscode per bestelling.<br><div class='pt-1'><span class='tw-font-semibold'>Cadeaubonnen:</span> Kunnen gecombineerd worden met kortingscodes.</div>",
  yourAccountHasBeenSuccessfullyCreated: "Je account is succesvol aangemaakt",
  watch: "Bekijk",
  returnItems: "Geen retouritems | Retouritem | Retouritems",
  requestReturn: "Retour aanvragen",
  cancel: "Annuleren",
  refundType: "Type terugbetaling",
  writeAFewWords: "Schrijf een korte toelichting",
  reason: "Reden",
  selectReason: "Selecteer reden",
  additionalComment: "Extra opmerking",
  returnAndRefund: "Retour en terugbetaling",
  repairResize: "Reparatie/herstellen",
  returnRequested: "Retour aangevraagd",
  phonePlaceholder: "+31XXXXXXXXX",
  send: "Verzenden",
  name: "Naam",
  campaignsTarget: "Campagnedoel",
  additionalDetails: "Aanvullende details",
  paymentCanceled: "Betaling geannuleerd",
  paymentTimeoutMessage: "De betaling duurt langer dan verwacht. Probeer het opnieuw.",
  payNow: "Nu betalen",
  discountCodeIsIncorrect: "Kortingscode is ongeldig",
  continueWithoutDiscount: "Doorgaan zonder korting",
  yes: "Ja",
  no: "Nee",
  search: "Zoeken",
  readTheArticle: "Lees het artikel",
  nextArticle: "Volgend artikel",
  topSuggestions: "Top suggesties",
  noResultsFound: "Geen resultaten gevonden",
  noResultsFoundText: "Helaas, je zoekopdracht leverde geen resultaten op. Probeer iets anders of neem contact met ons op.",
  articleDescription: "De nieuwste artikelen over",
  ourBlog: "Onze Blog",
  freeShippingByDate: "Gratis verzending op <span class='tw-font-normal'>{date}</span> bij bestelling vandaag",
  freeDaysReturns: "Gratis retour binnen {days} dagen",
  shippingDateNotAvailable: "Datum niet beschikbaar",
  certificateIssuer: "Certificaatautoriteit",
  certificateUrl: "Certificaat-URL",
  // Mollie card form labels and placeholders
  cardHolderName: "Naam",
  cardNumber: "Kaartnummer",
  expiryDate: "Vervaldatum",
  cvc: "CVC",
  enterCardholderName: "Voer kaarthouder naam in",
  cardNumberPlaceholder: "1234 1234 1234 1234",
  expiryDatePlaceholder: "MM/JJ",
  cvcPlaceholder: "123",
  finalSale: "Eindverkoop",
  nonRefundable: "Niet terugbetaalbaar",
  youMightAlsoLike: "Misschien vind je dit ook leuk",
};
